import styled from 'styled-components';

export const Wrapper = styled.div`
  background: var(--color-dark-100);
`;
